export default __webpack_public_path__ + "b634d50ff6fce3d9c553f38dccd5821f.png";